import React from "react";

import { formatNumber, goTo, useNavigate, useTranslation } from "utils";

import { Card, Icon, LazyLoadImage, Progress } from "components";

export const CourseCard = ({ course }) => {
  const { t } = useTranslation("courses");
  const navigate = useNavigate();

  const CourseProgress = ({ progress }) => (
    <div className="course-progress">
      <div>{progress}%</div>

      <Progress percent={progress} showInfo={false} strokeColor="#FFFFFF" strokeWidth="0.25rem" trailColor="#999999" />
    </div>
  );

  if (!course) {
    return <></>;
  }

  return (
    <Card className="course-card" onClick={(e) => goTo(e, navigate, `/course/${course.slug}`)} mixpanelText={course.title}>
      <LazyLoadImage className="image" src={course.images.s} />
      <div className="content-container">
        <p className="white-text paragraph-s margin-bottom-25">{t("card.course")}</p>
        <h4 className="white-text margin-bottom-100">{course.title}</h4>
        {course.progress.summary < 0 ? (
          <div className="icon-row">
            <div className="icon-container">
              <Icon iconName="tabler/clock" />
              <span>
                &#177;{" "}
                {t("card.duration", {
                  duration: formatNumber({
                    number: course.duration / 3600,
                    decimalPlaces: 1,
                  }),
                })}
              </span>
            </div>
            <div className="icon-container">
              <Icon iconName="tabler/movie" />
              <span>{course.videos}</span>
            </div>
            <div className="icon-container">
              <Icon iconName="tabler/news" />
              <span>{course.articles}</span>
            </div>
          </div>
        ) : course.progress.summary === 100 ? (
          <div className="icon-row">
            <div className="icon-container">
              <Icon color="#FFFFFF" iconName="tabler/circle-check" />
              <span>{t("card.done")}</span>
            </div>
          </div>
        ) : (
          <CourseProgress progress={course.progress.summary} />
        )}
      </div>
    </Card>
  );
};
